import PropTypes from "prop-types";
import feedbackTimescaleOptionsType from "./feedbackTimescaleOptionsType";
import sectorOptionsType from "./sectorOptionsType";
import vacancyReasonOptionsType from "./vacancyReasonOptionsType";
import notificationRecipientsType from "./notificationRecipientsType";
import audienceMembersType from "./audienceMembersType";

export default PropTypes.shape({
  accountManager: PropTypes.string.isRequired,
  accountManagerAvatar: PropTypes.string.isRequired,
  applicationsAtOfferOrAccepted: PropTypes.bool.isRequired,
  audienceId: PropTypes.number,
  audienceMemberIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  audienceMembers: audienceMembersType,
  benefitIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  benefitOptions: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number, name: PropTypes.string })
  ).isRequired,
  burst: PropTypes.bool,
  closeJobUrl: PropTypes.string.isRequired,
  considerRelocation: PropTypes.bool.isRequired,
  contractDuration: PropTypes.number,
  contractDurationInterval: PropTypes.string,
  copyJobUrl: PropTypes.string.isRequired,
  cvLimitPerRecruiter: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  currencyIsoCode: PropTypes.string.isRequired,
  currencySymbol: PropTypes.string.isRequired,
  dateCreated: PropTypes.string,
  degreeRequired: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  employerAccountType: PropTypes.string,
  exclusive: PropTypes.bool.isRequired,
  feedbackTimescaleId: PropTypes.number.isRequired,
  feedbackTimescaleOptions: feedbackTimescaleOptionsType.isRequired,
  finalSalary: PropTypes.number,
  interviewComments: PropTypes.string,
  interviewStages: PropTypes.number.isRequired,
  isJobActive: PropTypes.bool.isRequired,
  jobId: PropTypes.number,
  jobStatus: PropTypes.string,
  jobTitle: PropTypes.string.isRequired,
  jobType: PropTypes.string.isRequired,
  keySkills: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  notificationRecipientIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  notificationRecipients: notificationRecipientsType,
  publishedStatus: PropTypes.string,
  recruiterFeePercentage: PropTypes.string,
  salaryMax: PropTypes.number,
  salaryMin: PropTypes.number.isRequired,
  salaryRange: PropTypes.string,
  salaryType: PropTypes.string.isRequired,
  sectorId: PropTypes.number.isRequired,
  sectorOptions: sectorOptionsType.isRequired,
  url: PropTypes.string.isRequired,
  vacancyReason: PropTypes.number.isRequired,
  vacancyReasonOptions: vacancyReasonOptionsType.isRequired,
  validateUrl: PropTypes.string.isRequired,
  visaSponsorship: PropTypes.bool.isRequired,
});
